var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.049,
    height: 195.87,
    viewBox: "0 0 235.049 195.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(411.146 -459.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(-264.22 479.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M-220.34,533.823s8.334-35.322,36.448-39.205a6.931,6.931,0,0,1,7.292,5.351c1.822,6.023-9.054,6.067-15.777,8.49S-214.772,521.153-220.34,533.823Z",
    transform: "translate(221.122 -487.109)",
    fill: "#cedfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M-221.207,525.029s-2.922-29.257,17.594-39.642a5.615,5.615,0,0,1,7,2.179c2.983,4.135-5.338,7.034-9.851,10.661S-220.28,513.854-221.207,525.029Z",
    transform: "translate(221.351 -484.925)",
    fill: "#cedfff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(-371.524 515.44)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M-315.734,562.892s12.059-6.753,6.431-15.917c0,0-4.5-5.627-9.325-7.075,0,0,2.572,13.666,0,13.988s-1.769-15.435-1.769-15.435-12.7-6.109-17.685-5.627c0,0,7.878,13.344,5.305,13.023s-11.415-13.827-11.415-13.827-13.022-2.411-15.113,5.3,1.286,11.576,3.216,12.059,14.309.321,13.987,1.929-8.682,4.18-13.344,2.734c0,0,5.145,12.7,11.9,12.058s8.843-4.823,13.023-5.145,7.235.8,5.145,1.93-9.164.368-12.541,3.239-6.109,4.639.161,5.925,17.525.482,19.775-4.341Z",
    transform: "translate(359.964 -531.666)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(6.608 8.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M-351.428,542.1s33.764,10.933,37.622,23.152a25.644,25.644,0,0,0,3.216,11.737V579.4s-3.537-8.2-5.467-9.325C-316.057,570.071-308.5,559.46-351.428,542.1Z",
    transform: "translate(351.428 -542.096)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M-299.146,586.726a22.268,22.268,0,0,1,2.238,17.532l-1.339-.36s1.3-10.6-1.424-15.933S-299.146,586.726-299.146,586.726Z",
    transform: "translate(339.983 -551.838)",
    fill: "#a9c2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(-411.146 571.585)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M-320.6,633.793s7.9-23.665-10.748-29.067c0,0-12.847-2.046-21.045,1.881,0,0,20.036,15.124,16.992,18.678s-21.112-18.462-21.112-18.462-24.383,7.271-30.452,13.97c0,0,26.731,8.25,22.9,10.946s-32.04-4.6-32.04-4.6-20.319,12.6-13.736,25.444,15.78,13.9,18.942,12.2,19.5-16.953,21.022-14.416-6.515,16.129-14.5,19.861c0,0,22.3,10.711,30.536,1.649s5.948-17.183,11.141-22.69,10.637-7.715,9.214-3.673-11.79,11.625-12.811,19.559-2.524,13.617,7.412,7.717,23.988-20.645,21.134-29.82Z",
    transform: "translate(411.146 -604.193)",
    fill: "#cedfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(12.186 26.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M-395.4,656.353s58.368-26.416,78.364-14.787c0,0,6.8,8.334,2.853,9.175C-314.187,650.741-316.986,627.392-395.4,656.353Z",
    transform: "translate(395.404 -638.608)",
    fill: "#cedfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(-264.767 591.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M-184.338,642.152s2.327-14.153,13.258-11.9c0,0,7.083,2.4,10.2,6.6,0,0-14.245,2.321-13.649,4.944s15.687-3.73,15.687-3.73,10.451,10.235,11.742,15.269c0,0-15.806-2.971-14.583-.574s17.527,6.252,17.527,6.252,6.956,11.855.164,16.623-11.751,2.836-12.9,1.124-5.371-13.849-6.826-12.967-1.01,9.95,2.049,13.988c0,0-14.212-.531-15.972-7.347s1.582-10.334.417-14.527-3.341-6.776-3.7-4.338,2.88,9.073,1.272,13.382-2.367,7.6-5.838,1.937-6.665-16.93-2.754-20.831Z",
    transform: "translate(214.827 -630.007)",
    fill: "#b6cfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(0 12.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M-151.144,674.221s-22.6-29.082-35.889-28.528a26.617,26.617,0,0,1-12.59,1.011l-2.353.852s9.252.553,11.032,2.038C-190.944,649.594-183.261,638.469-151.144,674.221Z",
    transform: "translate(217.521 -645.685)",
    fill: "#b6cfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M-204.158,646.883a23.108,23.108,0,0,0-17.9,4.012l.824,1.18s9.885-5.016,16.051-4.242S-204.158,646.883-204.158,646.883Z",
    transform: "translate(222.057 -645.864)",
    fill: "#b6cfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(-248.217 506.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M-190.989,558.838s-14.739-8.255-7.861-19.457c0,0,5.5-6.878,11.4-8.647,0,0-3.145,16.7,0,17.1s2.162-18.867,2.162-18.867,15.526-7.468,21.618-6.878c0,0-9.63,16.312-6.486,15.918s13.954-16.9,13.954-16.9,15.918-2.948,18.474,6.486-1.572,14.15-3.931,14.739-17.491.393-17.1,2.359,10.612,5.109,16.312,3.341c0,0-6.289,15.525-14.544,14.739s-10.809-5.9-15.918-6.289-8.844.982-6.289,2.359,11.2.451,15.329,3.959,7.468,5.671-.2,7.243-21.422.59-24.173-5.306Z",
    transform: "translate(200.679 -520.668)",
    fill: "#cedfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(1.905 9.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M-143.321,533.417s-41.271,13.364-45.988,28.3a31.352,31.352,0,0,1-3.93,14.346v2.948s4.323-10.023,6.682-11.4C-186.557,567.613-195.794,554.642-143.321,533.417Z",
    transform: "translate(197.093 -533.417)",
    fill: "#cedfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M-194.364,587.972s-6.365,9.665-2.736,21.43l1.637-.44s-1.59-12.958,1.74-19.476S-194.364,587.972-194.364,587.972Z",
    transform: "translate(198.218 -545.325)",
    fill: "#cedfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(-337.397 504.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9968",
    "data-name": "Rectangle 9968",
    width: 110.174,
    height: 150.665,
    fill: "#6b98f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9969",
    "data-name": "Rectangle 9969",
    width: 100.785,
    height: 142.448,
    transform: "translate(4.695 4.066)",
    fill: "#f1f9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(16.394 126.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9970",
    "data-name": "Rectangle 9970",
    width: 12.469,
    height: 1.262,
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9971",
    "data-name": "Rectangle 9971",
    width: 12.469,
    height: 1.262,
    transform: "translate(15.357)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9972",
    "data-name": "Rectangle 9972",
    width: 17.293,
    height: 1.262,
    transform: "translate(0 2.801)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(11.359 35.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(65.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(0 3.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M-197.965,585.488h-18.228V567.259h18.228Zm-17.37-.859h16.511V568.118h-16.511Z",
    transform: "translate(216.193 -567.259)",
    fill: "#a8ccff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(2.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M-205.852,580.912a1.288,1.288,0,0,1-.992-.467l-5.625-6.8a1.287,1.287,0,0,1,.172-1.813,1.287,1.287,0,0,1,1.813.172l4.461,5.4,8.07-13.545a1.288,1.288,0,0,1,1.766-.447,1.287,1.287,0,0,1,.447,1.765l-9,15.114a1.286,1.286,0,0,1-1.008.625C-205.786,580.911-205.818,580.912-205.852,580.912Z",
    transform: "translate(212.764 -563.222)",
    fill: "#B8C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0 5.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(11.25 0.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9973",
    "data-name": "Rectangle 9973",
    width: 40.494,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0 7.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9974",
    "data-name": "Rectangle 9974",
    width: 37.319,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(0 3.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9975",
    "data-name": "Rectangle 9975",
    width: 11.039,
    height: 1.778,
    transform: "translate(29.456)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9976",
    "data-name": "Rectangle 9976",
    width: 26.397,
    height: 1.778,
    fill: "#a9c2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M-299.021,572.264l-1.811.5-.374-1.438,2.7-.862h1.236V580.6h-1.754Z",
    transform: "translate(301.206 -570.467)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M-294.621,582.547a.64.64,0,0,1,.64-.64.64.64,0,0,1,.64.64.64.64,0,0,1-.64.64A.64.64,0,0,1-294.621,582.547Z",
    transform: "translate(299.719 -573.051)",
    fill: "#a9c2ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(11.281 62.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083",
    transform: "translate(66.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(0 3.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M-197.782,620.662H-216.01V602.434h18.228Zm-17.369-.859h16.511V603.293h-16.511Z",
    transform: "translate(216.01 -602.434)",
    fill: "#a8ccff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082",
    transform: "translate(2.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M-205.669,616.086a1.287,1.287,0,0,1-.992-.468l-5.625-6.8a1.288,1.288,0,0,1,.172-1.813,1.288,1.288,0,0,1,1.813.172l4.461,5.4,8.07-13.544a1.288,1.288,0,0,1,1.766-.447,1.288,1.288,0,0,1,.447,1.766l-9.005,15.113a1.289,1.289,0,0,1-1.007.625C-205.6,616.085-205.636,616.086-205.669,616.086Z",
    transform: "translate(212.581 -598.396)",
    fill: "#B8C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(0 5.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M-301.307,614.393l3.441-2.927c1.37-1.157,1.87-1.8,1.87-2.7a1.5,1.5,0,0,0-1.613-1.556c-.914,0-1.542.5-2.313,1.5l-1.242-.971a4.1,4.1,0,0,1,3.683-2.1,3,3,0,0,1,3.3,3.013c0,1.57-.842,2.413-2.6,3.869l-2.055,1.713h4.754v1.542h-7.224Z",
    transform: "translate(301.307 -605.641)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M-290.439,617.729a.636.636,0,0,1,.636-.636.636.636,0,0,1,.636.636.636.636,0,0,1-.636.636A.636.636,0,0,1-290.439,617.729Z",
    transform: "translate(298.852 -608.228)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(11.664 0.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9977",
    "data-name": "Rectangle 9977",
    width: 42.552,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "translate(0 7.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9978",
    "data-name": "Rectangle 9978",
    width: 39.216,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "translate(0 3.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9979",
    "data-name": "Rectangle 9979",
    width: 11.6,
    height: 1.778,
    transform: "translate(30.953)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9980",
    "data-name": "Rectangle 9980",
    width: 27.738,
    height: 1.778,
    fill: "#a9c2ff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103",
    transform: "translate(11.155 90.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(66.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(0 3.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M-197.782,656.1H-216.01V637.868h18.228Zm-17.369-.858h16.511V638.727h-16.511Z",
    transform: "translate(216.01 -637.868)",
    fill: "#a8ccff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094",
    transform: "translate(2.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M-205.669,651.521a1.287,1.287,0,0,1-.992-.468l-5.625-6.8a1.288,1.288,0,0,1,.172-1.813,1.287,1.287,0,0,1,1.813.173l4.461,5.4,8.07-13.544a1.289,1.289,0,0,1,1.766-.447,1.289,1.289,0,0,1,.447,1.766l-9.005,15.113a1.289,1.289,0,0,1-1.007.625C-205.6,651.519-205.636,651.521-205.669,651.521Z",
    transform: "translate(212.581 -633.831)",
    fill: "#B8C7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(11.79 5.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9981",
    "data-name": "Rectangle 9981",
    width: 42.552,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(0 7.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9982",
    "data-name": "Rectangle 9982",
    width: 39.216,
    height: 1.778,
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "translate(0 3.972)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9983",
    "data-name": "Rectangle 9983",
    width: 11.6,
    height: 1.778,
    transform: "translate(30.953)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9984",
    "data-name": "Rectangle 9984",
    width: 27.738,
    height: 1.778,
    fill: "#a9c2ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102",
    transform: "translate(0 5.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M-301.47,649.427l1.2-1.118a3.188,3.188,0,0,0,2.57,1.285,1.535,1.535,0,0,0,1.691-1.509c0-.964-.88-1.509-2.25-1.509h-.8l-.279-1.076,2.641-2.808h-4.234V641.2h6.469v1.285l-2.724,2.795c1.551.223,2.878,1.02,2.878,2.78a3.129,3.129,0,0,1-3.423,3.087A4.635,4.635,0,0,1-301.47,649.427Z",
    transform: "translate(301.47 -641.198)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M-291.576,653.062a.622.622,0,0,1,.622-.622.622.622,0,0,1,.622.622.622.622,0,0,1-.622.622A.622.622,0,0,1-291.576,653.062Z",
    transform: "translate(299.235 -643.737)",
    fill: "#a9c2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108",
    transform: "translate(51.516 111.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104",
    transform: "translate(3.405 11.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M-237.349,683.611a7.754,7.754,0,0,1-7.574-6.174.529.529,0,0,1,.413-.625.53.53,0,0,1,.625.413,6.692,6.692,0,0,0,6.537,5.327,6.7,6.7,0,0,0,6.524-5.264.53.53,0,0,1,.629-.406.529.529,0,0,1,.406.629A7.768,7.768,0,0,1-237.349,683.611Z",
    transform: "translate(244.934 -676.802)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(3.391 3.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M-244.423,672.508a.57.57,0,0,1-.1-.009.529.529,0,0,1-.419-.621,7.739,7.739,0,0,1,7.59-6.253,7.719,7.719,0,0,1,7.5,5.843.53.53,0,0,1-.385.643.529.529,0,0,1-.643-.385,6.661,6.661,0,0,0-6.472-5.041,6.678,6.678,0,0,0-6.55,5.395A.53.53,0,0,1-244.423,672.508Z",
    transform: "translate(244.953 -665.624)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M-238.343,683.395a11,11,0,0,1-10.99-10.99,11,11,0,0,1,10.99-10.99,11,11,0,0,1,10.99,10.99A11,11,0,0,1-238.343,683.395Zm0-20.475a9.5,9.5,0,0,0-9.485,9.485,9.5,9.5,0,0,0,9.485,9.485,9.5,9.5,0,0,0,9.485-9.485A9.5,9.5,0,0,0-238.343,662.92Z",
    transform: "translate(249.333 -661.414)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107",
    transform: "translate(7.787 9.614)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9985",
    "data-name": "Rectangle 9985",
    width: 4.353,
    height: 0.697,
    transform: "translate(1.027)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9986",
    "data-name": "Rectangle 9986",
    width: 4.353,
    height: 0.697,
    transform: "translate(1.027 2.851)",
    fill: "#a9c2ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9987",
    "data-name": "Rectangle 9987",
    width: 6.407,
    height: 0.697,
    transform: "translate(0 1.377)",
    fill: "#a9c2ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13613",
    "data-name": "Path 13613",
    d: "M6.457-7.788v1.727h-2.1V0H2.2V-6.061H.121V-7.788ZM9.339-5.016a2.826,2.826,0,0,1,.913-.88,2.23,2.23,0,0,1,1.166-.33v2.31h-.627A1.765,1.765,0,0,0,9.7-3.635a1.16,1.16,0,0,0-.363.974V0H7.172V-6.171H9.339Zm5.082-1.232a2.189,2.189,0,0,1,1.128.28,1.728,1.728,0,0,1,.709.776v-.979h2.156V0H16.258V-.979a1.728,1.728,0,0,1-.709.776,2.189,2.189,0,0,1-1.128.281A2.42,2.42,0,0,1,13.09-.3a2.569,2.569,0,0,1-.935-1.1,3.909,3.909,0,0,1-.341-1.688,3.873,3.873,0,0,1,.341-1.683,2.574,2.574,0,0,1,.935-1.095A2.42,2.42,0,0,1,14.421-6.248Zm.715,1.892a1.07,1.07,0,0,0-.819.335,1.308,1.308,0,0,0-.314.93,1.325,1.325,0,0,0,.314.94,1.07,1.07,0,0,0,.819.336,1.053,1.053,0,0,0,.8-.341,1.314,1.314,0,0,0,.319-.935,1.3,1.3,0,0,0-.319-.924A1.053,1.053,0,0,0,15.136-4.356ZM21.89-6.248a2.16,2.16,0,0,1,1.122.28,1.737,1.737,0,0,1,.7.776V-8.14h2.167V0H23.716V-.979a1.737,1.737,0,0,1-.7.776A2.16,2.16,0,0,1,21.89.077,2.42,2.42,0,0,1,20.559-.3a2.569,2.569,0,0,1-.935-1.1,3.909,3.909,0,0,1-.341-1.688,3.873,3.873,0,0,1,.341-1.683,2.574,2.574,0,0,1,.935-1.095A2.42,2.42,0,0,1,21.89-6.248ZM22.6-4.356a1.07,1.07,0,0,0-.819.335,1.308,1.308,0,0,0-.313.93,1.325,1.325,0,0,0,.313.94,1.07,1.07,0,0,0,.819.336,1.053,1.053,0,0,0,.8-.341,1.314,1.314,0,0,0,.319-.935,1.3,1.3,0,0,0-.319-.924A1.053,1.053,0,0,0,22.6-4.356ZM33-3.2a2.6,2.6,0,0,1-.055.506H28.864q.055,1.045.913,1.045A.866.866,0,0,0,30.3-1.8a.771.771,0,0,0,.286-.407h2.288a2.617,2.617,0,0,1-.539,1.171,2.893,2.893,0,0,1-1.056.819,3.269,3.269,0,0,1-1.4.3A3.41,3.41,0,0,1,28.253-.3a2.685,2.685,0,0,1-1.106-1.1,3.451,3.451,0,0,1-.4-1.688,3.42,3.42,0,0,1,.4-1.683,2.685,2.685,0,0,1,1.111-1.095,3.419,3.419,0,0,1,1.628-.379,3.419,3.419,0,0,1,1.628.374A2.668,2.668,0,0,1,32.61-4.807,3.216,3.216,0,0,1,33-3.2Zm-2.2-.4a.892.892,0,0,0-.253-.715.94.94,0,0,0-.66-.242,1.006,1.006,0,0,0-.7.242,1.05,1.05,0,0,0-.313.715ZM41.987-6.226a2.363,2.363,0,0,1,1.821.7,2.732,2.732,0,0,1,.654,1.936V0H42.306V-3.311a1.041,1.041,0,0,0-.275-.77,1,1,0,0,0-.737-.275,1.033,1.033,0,0,0-.764.28,1.079,1.079,0,0,0-.281.8V0H38.093V-3.311a1.041,1.041,0,0,0-.275-.77,1,1,0,0,0-.737-.275,1.033,1.033,0,0,0-.764.28,1.079,1.079,0,0,0-.28.8V0H33.869V-6.171h2.167v.946a1.935,1.935,0,0,1,.737-.731,2.206,2.206,0,0,1,1.111-.27,2.379,2.379,0,0,1,1.221.308,2.127,2.127,0,0,1,.825.88,2.45,2.45,0,0,1,.858-.863A2.28,2.28,0,0,1,41.987-6.226Zm5.907-.022a2.189,2.189,0,0,1,1.127.28,1.728,1.728,0,0,1,.71.776v-.979h2.156V0H49.731V-.979a1.728,1.728,0,0,1-.71.776,2.189,2.189,0,0,1-1.127.281A2.42,2.42,0,0,1,46.563-.3a2.569,2.569,0,0,1-.935-1.1,3.909,3.909,0,0,1-.341-1.688,3.873,3.873,0,0,1,.341-1.683,2.574,2.574,0,0,1,.935-1.095A2.42,2.42,0,0,1,47.894-6.248Zm.715,1.892a1.07,1.07,0,0,0-.819.335,1.308,1.308,0,0,0-.313.93,1.325,1.325,0,0,0,.313.94,1.07,1.07,0,0,0,.819.336,1.053,1.053,0,0,0,.8-.341,1.314,1.314,0,0,0,.319-.935,1.3,1.3,0,0,0-.319-.924A1.053,1.053,0,0,0,48.609-4.356Zm6.633-.66a2.826,2.826,0,0,1,.913-.88,2.23,2.23,0,0,1,1.166-.33v2.31h-.627a1.765,1.765,0,0,0-1.089.281,1.16,1.16,0,0,0-.363.974V0H53.075V-6.171h2.167ZM61.886,0,60.2-2.552V0H58.036V-8.14H60.2v4.367l1.694-2.4h2.519l-2.4,3.091L64.482,0Z",
    transform: "translate(19.396 24.616)",
    fill: "#a9c2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(-380.71 556.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M-327.239,613.873s.342-.769.564-1.134,1.169-1.433,1.331-1.191.806,1.87.463,2.326.022,1.249-1.681,1.729Z",
    transform: "translate(361.758 -590.582)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M-351.7,608.282s8.722,7.281,12.123,6.607a67.058,67.058,0,0,0,6.741-1.927l.817,2.088s-3.661,4.965-7.477,5a21.739,21.739,0,0,1-10.373-2.582Z",
    transform: "translate(367.283 -589.852)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M-371.459,707.1s.253,4.085,1.044,4.143c.1.008,4.008.008,4.008.008l4.982-.029a1.617,1.617,0,0,0-1.489-1.455c-1.457-.253-3.894-1.277-4.776-3.2C-368.619,704.543-371.459,707.1-371.459,707.1Z",
    transform: "translate(371.746 -611.876)",
    fill: "#074a92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M-371.83,693.14a10.391,10.391,0,0,0,2.7.506,9.9,9.9,0,0,0,2.517-.359,69.03,69.03,0,0,1,1.855-8.834c.822-3.184,2-7.279,3.669-12.367,4.622-14.062,6.027-22.288,6.155-23.067.007-.041.009-.062.009-.062l-.015-.007-14.208-6.238s1.756,19.38-.484,26.819a31.3,31.3,0,0,0-.814,3.564C-371.863,681.176-371.83,693.14-371.83,693.14Z",
    transform: "translate(371.83 -597.629)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M-364.124,684.453c.822-3.184,2-7.279,3.669-12.367,4.622-14.062,6.027-22.288,6.155-23.067,0-.024,0-.046-.005-.069l-14.208-6.238s1.757,19.38-.484,26.819C-369.312,670.572-364.124,684.453-364.124,684.453Z",
    transform: "translate(371.194 -597.629)",
    fill: "#2cb5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M-357.124,707.1s.253,4.085,1.044,4.143c.1.008,4.008.008,4.008.008l4.982-.029a1.617,1.617,0,0,0-1.489-1.455c-1.456-.253-3.894-1.277-4.776-3.2C-354.284,704.543-357.124,707.1-357.124,707.1Z",
    transform: "translate(368.508 -611.876)",
    fill: "#074a92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M-351.126,643.3a202.211,202.211,0,0,1-1.988,27.979c-2.173,15.42-1.437,21.965-1.437,21.965a14.761,14.761,0,0,1-2.095.533,9.5,9.5,0,0,1-3.109-.359s-3.11-15.426-2.219-23.144-4.259-26.484-4.259-26.484Z",
    transform: "translate(370.566 -597.762)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M-359.733,603.528l2.774,1.818,2.526-.714a6.035,6.035,0,0,0,.591-3.029,18.787,18.787,0,0,0-.1-2.017l-3.741-1.651-1.4-.615c0,.022.109,1.146.124,1.311A9.547,9.547,0,0,1-359.733,603.528Z",
    transform: "translate(369.098 -587.376)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M-351.746,637.912c-3.452,3.333-16.516,2.772-17.321-.9s.878-31.26,6.775-32.993c1.223-.359,7.765,1.755,7.765,1.755a41.454,41.454,0,0,1,1.7,6.1c.131.666.513,7.716.8,14.311.133,3.084.246,6.071.3,8.257A23.772,23.772,0,0,1-351.746,637.912Z",
    transform: "translate(371.248 -588.88)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M-358.4,598.861c.759,1.283,3.422,2.407,4.834,2.922a18.783,18.783,0,0,0-.1-2.017l-3.741-1.651C-358.233,598.1-358.737,598.288-358.4,598.861Z",
    transform: "translate(368.82 -587.556)",
    fill: "#ffa05e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M-352.882,597.058s-6.028,1.881-7.142-1.891-2.641-6.071,1.161-7.431,4.978-.142,5.656,1.026S-351.342,596.472-352.882,597.058Z",
    transform: "translate(369.449 -585.076)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M-354.209,587.8s-.385,4.39-1.293,4.2-1.907-.6-1.774.725-.883,3.592-2.192,3.587c-2.808-.012-5.859-7.216-5.09-8.582C-362.339,583.784-351,582.989-354.209,587.8Z",
    transform: "translate(370.215 -584.475)",
    fill: "#0b3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M-354.1,603.614c-.078-.032-4.488-2.011-5-1.84s-1.159,1.745-1.159,1.745l7.766,1.756A3.861,3.861,0,0,0-354.1,603.614Z",
    transform: "translate(369.217 -588.38)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    transform: "translate(15.541 2.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M-324.72,631.064l-24.723,23.277c-.485.456-1.1.6-1.358.323l-.835-.886c-.262-.279-.081-.879.4-1.336l24.723-23.276c.485-.456,1.1-.6,1.358-.323l.835.886C-324.054,630.007-324.236,630.607-324.72,631.064Z",
    transform: "translate(351.755 -597.244)",
    fill: "#0b4d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M-338.593,648.073l-10.849,10.215c-.485.456-1.1.6-1.358.323l-.835-.886c-.262-.279-.081-.879.4-1.336l10.849-10.214Z",
    transform: "translate(351.755 -601.191)",
    fill: "#6b98f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M-324.417,613.1a19.28,19.28,0,0,0,5.259,8.459,19.379,19.379,0,0,0,27.391-.835,19.374,19.374,0,0,0-.532-27.1c-.1-.1-.2-.2-.3-.293a19.375,19.375,0,0,0-27.389.834A19.368,19.368,0,0,0-324.417,613.1Zm5.539-17.884a17.827,17.827,0,0,1,16.057-5.355,17.757,17.757,0,0,1,9.17,4.587,17.846,17.846,0,0,1,.769,25.227,17.777,17.777,0,0,1-8.872,5.137,17.83,17.83,0,0,1-16.357-4.367A17.847,17.847,0,0,1-318.878,595.214Z",
    transform: "translate(345.77 -588.066)",
    fill: "#0b4d87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(22.042 1.53)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M-292.435,620.119a17.777,17.777,0,0,1-8.872,5.137,17.832,17.832,0,0,1-16.357-4.367,17.847,17.847,0,0,1-.769-25.229,17.827,17.827,0,0,1,16.058-5.355,17.76,17.76,0,0,1,9.17,4.585A17.848,17.848,0,0,1-292.435,620.119Z",
    transform: "translate(323.282 -590.043)",
    fill: "#accefc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M-350.263,636.724c-13.622-9.708-12.49-22.66-12.49-22.66,4.979,2.809,9.92,9.017,12.186,14.4C-350.433,631.552-350.32,634.538-350.263,636.724Z",
    transform: "translate(369.785 -591.158)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(6.748 16.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M-329.72,637.312a3.712,3.712,0,0,0,1.739-1.074s.41.028-.067.9c-.04.073-.129.261-.2.394a.085.085,0,0,0,.071.122,9.081,9.081,0,0,1,2.18.046c.147.031.19.384.184.534a1.361,1.361,0,0,1-.286.93,4.772,4.772,0,0,1-1.722.9,5.206,5.206,0,0,1-2.664-.334l-.872-.4.27-1.62.219.046C-330.513,637.826-330.083,637.4-329.72,637.312Z",
    transform: "translate(355.939 -613.061)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M-358.6,606.3s-12.241,2.331,3.6,20.056c2.534,2.834,16.222,6.526,16.222,6.526s1.388-1.181.688-2.138c0,0-9.424-6.843-11.5-7.932-.933-.489-3.621-10.924-5.141-13.437A6.854,6.854,0,0,0-358.6,606.3Z",
    transform: "translate(363.113 -606.299)",
    fill: "#899bfa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M-326.811,613.97a6.239,6.239,0,0,0,.479-1.169,6.458,6.458,0,0,1,.79-1.787c.083-.084.357.024.389.381a2.075,2.075,0,0,1-.2.774,8.74,8.74,0,0,0-.259,1.538C-325.8,614.323-326.811,613.97-326.811,613.97Z",
    transform: "translate(361.662 -590.463)",
    fill: "#ffae73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(-305.433 642.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M-274.589,703.907a4.739,4.739,0,0,0,.039.615,5.01,5.01,0,0,0,.574,1.8,5.034,5.034,0,0,0,.865,1.156,5.037,5.037,0,0,0,3.571,1.479h71.019a5.05,5.05,0,0,0,5.05-5.05,5.028,5.028,0,0,0-1.479-3.571,5.029,5.029,0,0,0-3.571-1.479h-71.019A5.05,5.05,0,0,0-274.589,703.907Z",
    transform: "translate(274.589 -696.393)",
    fill: "#25468f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M-267.817,697.224h24.349a.777.777,0,0,0,.775-.775h0a.777.777,0,0,0-.775-.775h-24.349a.778.778,0,0,0-.776.775h0A.777.777,0,0,0-267.817,697.224Z",
    transform: "translate(273.235 -695.674)",
    fill: "#25468f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9988",
    "data-name": "Rectangle 9988",
    width: 2.639,
    height: 0.914,
    transform: "translate(9.401 2.464) rotate(180)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M-273.8,708.5a5.034,5.034,0,0,0,.866,1.156,5.037,5.037,0,0,0,3.571,1.479h15.043V708.5Z",
    transform: "translate(274.41 -698.571)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M-181.327,702.428v2.958a3.588,3.588,0,0,1-.124.937,3.57,3.57,0,0,1-3.446,2.634h-73.978a3.569,3.569,0,0,1-3.445-2.634,3.589,3.589,0,0,1-.125-.937v-2.958a3.57,3.57,0,0,1,3.57-3.571H-184.9A3.569,3.569,0,0,1-181.327,702.428Z",
    transform: "translate(271.846 -696.393)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M-181.414,708.5a3.57,3.57,0,0,1-3.446,2.634h-73.978a3.569,3.569,0,0,1-3.445-2.634Z",
    transform: "translate(271.809 -698.571)",
    fill: "#2cb5a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(83.172 2.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M-167.15,703.925a5.611,5.611,0,0,0,1.469,3.9l.06.062a3.585,3.585,0,0,0,2.534,1.106c1.5,0,5.21-2.26,7.51-3.76,1.146-.748,1.942-1.307,1.942-1.307s-.8-.56-1.942-1.307c-2.3-1.5-6.012-3.761-7.51-3.761a3.358,3.358,0,0,0-1.243.24,4.073,4.073,0,0,0-1.712,1.352,5.585,5.585,0,0,0-1.028,2.472.235.235,0,0,0,0,.033A6.324,6.324,0,0,0-167.15,703.925Z",
    transform: "translate(167.15 -698.857)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M-167.15,705.12a5.611,5.611,0,0,0,1.469,3.9l11.386-3.917-12.78-.954A6.325,6.325,0,0,0-167.15,705.12Z",
    transform: "translate(167.15 -700.052)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M-165.719,700.519l11.359,3.1-9.646-4.454A4.074,4.074,0,0,0-165.719,700.519Z",
    transform: "translate(166.827 -698.927)",
    fill: "#9cafff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M-153.157,705.023a1.4,1.4,0,0,0,.741,1.308c1.146-.748,1.942-1.308,1.942-1.308s-.8-.56-1.942-1.307A1.4,1.4,0,0,0-153.157,705.023Z",
    transform: "translate(163.989 -699.954)",
    fill: "#122d4e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117",
    transform: "translate(-219.577 557.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M-131.506,585.979a4.289,4.289,0,0,0-3.389-.362c-5.756-.676-7.435,6.037-7.357,8.347s.342,4.79-2.229,7.791c-7.425,8.668,8.126,9.05,8.126,9.05.131-6.925,8.433-4.4,8.069-3.7C-117.644,609.662-127.228,588.2-131.506,585.979Z",
    transform: "translate(159.799 -585.426)",
    fill: "#0b3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M-157.593,621.111s-1.012-1.541-1.828-1.572-2.326-.453-2.206-.151,1.057.332,1.148.514-1.39.453-1.813.483-1.421,0-1.39.211a4.8,4.8,0,0,0,3.043.967,8.457,8.457,0,0,1,2.788.363Z",
    transform: "translate(163.682 -593.073)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M-141.357,618.7a15.2,15.2,0,0,1-1.548,2.341,9.06,9.06,0,0,1-5.386,3.591,5.792,5.792,0,0,1-3.2-.519h0a14.585,14.585,0,0,1-4.954-4.142,2.325,2.325,0,0,1,.317-2.281s5.711,1.284,6.254,1.013,3.888-7.69,4.49-8.926a6.773,6.773,0,0,1,3.313-3.38Z",
    transform: "translate(162.085 -590.162)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M-141.411,624.43a9.059,9.059,0,0,1-5.386,3.591,5.792,5.792,0,0,1-3.2-.519c.111.014,2.935.363,4.061-1.651,1.148-2.055,2.391-5.318,4.1-4.23C-141.1,622.09-141.136,623.257-141.411,624.43Z",
    transform: "translate(160.591 -593.553)",
    fill: "#2cb5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M-111.226,701.7s1.743,1.59,1.4,2.72-1.913,1.883-2.125,3.265-1.063,2.134-1.828,2.134h-3.647s-.564-.972.8-1.265,1.873-1.916,1.787-3.422a26.51,26.51,0,0,1,.128-3.515l2.891-.67Z",
    transform: "translate(153.26 -611.519)",
    fill: "#074a92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M-131.333,702.791s.627,6.737-.139,7.113l-9.79-.02s0-1.129,1.573-1.381,4.335-1.171,4.8-3.222S-131.333,702.791-131.333,702.791Z",
    transform: "translate(158.618 -611.935)",
    fill: "#074a92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M-123.868,613.919a39.1,39.1,0,0,1,0,4.526c-.1,1.636-1.753,3.827-1.987,4.369-.589,1.36-1.253,1.582-1.253,1.582l-5.141,1.259-1.808.443-5.7-1.7s-2.6-7.247-1.553-11.326a31.339,31.339,0,0,1,2.635-6.912s3.864-1.524,10.707-.386Z",
    transform: "translate(158.685 -589.926)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M-123.309,622.644a16,16,0,0,1-.482,3.7c-.589,1.36-1.253,1.582-1.253,1.582l-5.141,1.26-2.233-.656s7.453-1.129,6.627-7.542Z",
    transform: "translate(156.62 -593.459)",
    fill: "#f8caa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M-139.641,631.372s-2.822,8.786-3,11.778,5.4,42.494,5.62,43.873c.211,1.3,1.825,2.127,1.825,2.127a2.444,2.444,0,0,0,1.8.139,4.453,4.453,0,0,0,1.934-.912s2.2-28.173.838-38.237A159.454,159.454,0,0,1-132,631.372Z",
    transform: "translate(158.931 -595.804)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M-126.533,631.034s4.306,5.777,4.707,9.683.629,17.623,1.485,21.43,4,11.134,4,23.009a2.368,2.368,0,0,1-1.335,1.043,10.919,10.919,0,0,1-1.174.325,1.846,1.846,0,0,1-2.064-.98c-2.124-4.277-8.891-18.071-9.238-20.935-.245-2.026-2.382-15.438-7.042-23.307-1.119-1.89.687-9.4.687-9.4Z",
    transform: "translate(157.782 -595.728)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M-139.393,629.62a5.919,5.919,0,0,0,3.384.942c2.689.054,9.351-.686,9.351-.686a5.5,5.5,0,0,1,.284,1.7s-8.138,2.052-12.852.3A2.979,2.979,0,0,1-139.393,629.62Z",
    transform: "translate(158.232 -595.408)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116",
    transform: "translate(20.352 34.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M-136.165,633.02a1.317,1.317,0,0,1-1.227-1.389,1.317,1.317,0,0,1,1.227-1.389,1.317,1.317,0,0,1,1.227,1.389A1.317,1.317,0,0,1-136.165,633.02Zm0-2.37a.913.913,0,0,0-.821.982.913.913,0,0,0,.821.982.913.913,0,0,0,.82-.982A.913.913,0,0,0-136.165,630.649Z",
    transform: "translate(137.392 -630.242)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9989",
    "data-name": "Rectangle 9989",
    width: 11.055,
    height: 15.132,
    rx: 1.481,
    transform: "matrix(0.754, -0.657, 0.657, 0.754, 22.061, 31.649)",
    fill: "#25468f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M-126.347,631.708c-.094.025-3.51.427-3.511,1.132a2.125,2.125,0,0,0,1.945,1.859,11.225,11.225,0,0,0,2.145-1.642Z",
    transform: "translate(156.042 -595.88)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M-129.124,604.2a11.377,11.377,0,0,1-.609-4.155l-.258.051-4.34.859s.1,1.366.1,2.652v.032c.005,1.117-.755,2.239,1.037,2.682C-132.638,606.457-128.307,606.179-129.124,604.2Z",
    transform: "translate(157.064 -588.728)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M-134.315,600.969s.1,1.366.1,2.652c2.428-.069,3.712-2.284,4.238-3.511Z",
    transform: "translate(157.049 -588.743)",
    fill: "#f48f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M-135.92,599.964s5.745.1,5.749-3.484.749-5.977-2.919-6.189-4.382,1.153-4.674,2.347S-137.415,599.848-135.92,599.964Z",
    transform: "translate(157.844 -586.52)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M-135.088,589.973s1.573,4.2,3.988,4.82,3.461-.026,3.461-.026a6.835,6.835,0,0,1-2.236-4.039S-133.9,587.975-135.088,589.973Z",
    transform: "translate(157.223 -586.289)",
    fill: "#0b3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M-135.433,590.426a3.562,3.562,0,0,0-1.647,1.287,5.786,5.786,0,0,0-.776,3.285s-1.185-2.854.147-4.468C-136.3,588.818-135.433,590.426-135.433,590.426Z",
    transform: "translate(157.958 -586.401)",
    fill: "#0b3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M-126,631.65a3.9,3.9,0,0,0-1.366-.187c-.547.077-.952-.011-.952.142s.707.224.857.3A7.447,7.447,0,0,0-126,631.65Z",
    transform: "translate(155.694 -595.822)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M-124.543,605.9a6.954,6.954,0,0,1,5.641,4.086c1.564,3.8,4.529,10.182,4.529,11.254s-1.657,4.382-10.555,6.285c0,0-.92-.969-.864-1.734,0,0,5.554-4.771,5.54-5.328-.029-1.054-.911-2.447-5.787-7.326C-127.365,611.806-124.543,605.9-124.543,605.9Z",
    transform: "translate(155.26 -590.05)",
    fill: "#B8C7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(-342.398 459.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M-305.224,459.922s-3.272-.553-5.347,1.014-2.406,1.061-3.577,2.028.028,2.121-.618,2.766a1.323,1.323,0,0,0,.287,2.213c.958.322.313,2.074,2.387,2.3s1.145,1.191,3.113,1.337a17.3,17.3,0,0,1,4.632.649,1.639,1.639,0,0,0,2.274-.8c.3-.79,1.126.228,1.369-.851s-.622-1.506-.139-2.382S-299.163,461.1-305.224,459.922Z",
    transform: "translate(320.733 -459.828)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M-295.055,538.949a.807.807,0,0,0-.138.866l0,0a5.375,5.375,0,0,0,1.712,1.851c.1.082.194.156.274.225l.061.054.047.042c.752.683.471.843,1.822,2.23,1.54,1.579,2.593,1.6,2.891,1.454.253-.125-.268-.965-.845-1.91l-.084-.138c-.077-.125-.153-.252-.229-.378-.677-1.136-.509-1.674-.362-3.373.119-1.381,2.092-7.725,2.092-7.725l-2.933-.484s-.847,5.047-1.813,5.83c-.517.417-1.1.427-1.6.737-.035.021-.07.043-.1.066A3.867,3.867,0,0,0-295.055,538.949Z",
    transform: "translate(316.223 -476.054)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M-295.055,540.865a.807.807,0,0,0-.138.866l0,0a6.225,6.225,0,0,0,1.714,1.845c.1.084.191.159.272.232l.061.054.047.042c.752.683.471.843,1.822,2.229,1.54,1.579,2.593,1.6,2.891,1.454.253-.125-.268-.965-.845-1.91a6.511,6.511,0,0,1-2.74-1.989c-.928-1.168-1.553-2.673-2.186-3.542-.035.021-.07.043-.1.066A3.866,3.866,0,0,0-295.055,540.865Z",
    transform: "translate(316.223 -477.97)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M-265.193,536.652c.187.9,1.475.743,2.913.381s1.1.059,3.146-.183,2.664-1.009,2.724-1.315c.054-.271-.96-.358-2.047-.476l-.411-.046a8.879,8.879,0,0,1-3.25-1.572,13.014,13.014,0,0,1-2.652-3.106l-2.809.243s1.491,2.229,2.068,3.2a3.393,3.393,0,0,1,.29,1.914A3.606,3.606,0,0,0-265.193,536.652Z",
    transform: "translate(309.971 -475.753)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M-261.6,538.411c1.438-.362,1.1.059,3.146-.183s2.664-1.009,2.724-1.315c.054-.271-.96-.358-2.047-.476l-.01.021a5.776,5.776,0,0,1-2.929.933c-1.39.044-2.866-.344-3.827-.322a3.605,3.605,0,0,0,.029.961C-264.323,538.933-263.035,538.773-261.6,538.411Z",
    transform: "translate(309.288 -477.132)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M-281.358,514.069l-2.578,7.089-3.365,9.257a5.563,5.563,0,0,1-1.823-.154,7.9,7.9,0,0,1-1.769-.845s.883-9.92,2.62-15.623a10.121,10.121,0,0,1,1.5-3.317C-284.037,507.2-281.358,514.069-281.358,514.069Z",
    transform: "translate(315.237 -471.068)",
    fill: "#2cb5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M-289.514,500.531c-1.726-.543-6.63.2-11.555,1.2l-1.045-1.7-10.659-.756s-3.337,7.384-1.5,12.774c.356,1.046,2.062,1.083,2.063,1.083s6.244.068,8.3.054c5.3-.038,11.187-3.721,11.951-3.88,1.25-.259,1.769,2.242,3.04,4.863s11.853,11.563,11.853,11.563a9.276,9.276,0,0,0,2.283-.25,2.258,2.258,0,0,0,.977-.626S-285.624,501.756-289.514,500.531Z",
    transform: "translate(320.642 -468.74)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M-304.263,477.309a5.02,5.02,0,0,1-3.125.118,5.57,5.57,0,0,1-2.082-2.459c.539-.029,1.127-.5,1.561-3.6l.231.081,3.868,1.362s-.271,1.239-.444,2.42C-304.4,476.221-304.475,477.17-304.263,477.309Z",
    transform: "translate(319.433 -462.435)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M-303.288,472.835s-.165.869-.394,2.11a4.505,4.505,0,0,1-3.474-3.472Z",
    transform: "translate(318.91 -462.458)",
    fill: "#f9924f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M-302.82,472.108s-5.284-.672-4.815-3.956.1-5.582,3.5-5.293,3.869,1.637,3.979,2.771S-301.433,472.2-302.82,472.108Z",
    transform: "translate(319.025 -460.507)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M-300.812,463.748s-3.359,2.936-5.656,3.187-3.172-.481-3.172-.481a8.984,8.984,0,0,0,2.15-2.956,1.616,1.616,0,0,1,1.325-.962C-304.525,462.383-301.413,462.3-300.812,463.748Z",
    transform: "translate(319.471 -460.421)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M-300.967,463.62a8.323,8.323,0,0,1,1.5,1.893,6.387,6.387,0,0,1,.2,3.4s1.737-3.437.728-5.094A1.408,1.408,0,0,0-300.967,463.62Z",
    transform: "translate(317.512 -460.54)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M-301.065,486.066c-.084,10.687.016,8.453-1.146,9.475a4.486,4.486,0,0,1-2.113.473c-3.275.241-9.038-.259-9.262-.862-.77-2.09-.242-2.744-.895-5.948-.068-.341-.152-.709-.25-1.111-.541-2.2-1.058-2.946.782-6.5,1.669-3.218,3.408-5.832,3.566-5.739,4.481,2.617,4.825.388,4.825.388S-301.024,480.853-301.065,486.066Z",
    transform: "translate(320.735 -463.448)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M-283.936,522.384l-3.365,9.257a5.562,5.562,0,0,1-1.823-.154,7.9,7.9,0,0,1-1.769-.845s.883-9.92,2.62-15.623Z",
    transform: "translate(315.237 -472.294)",
    fill: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M-302.733,476.358s4.6.746,5.151,2.719,3.808,13.574,3.808,13.574-2.331.436-3.417-.635-3.823-9.979-3.823-9.979Z",
    transform: "translate(317.911 -463.562)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M-304.1,498.608c-3.275.241-9.038-.259-9.262-.862-.77-2.09-.242-2.744-.895-5.948l1.549-4.461s-.226,4.958,1.245,6.25,6,2.474,6.719,3.558A3.971,3.971,0,0,1-304.1,498.608Z",
    transform: "translate(320.515 -466.041)",
    fill: "#667ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M-306.008,499.086s3.227-.742,3.751-.459a7.569,7.569,0,0,1,1.968,1.681c.163.362-1.163-.268-1.593-.38a3.812,3.812,0,0,0-1.371.31,4.559,4.559,0,0,1-2.459.264Z",
    transform: "translate(318.651 -468.577)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M-311.99,475.854s-4.338.3-5.826,2.4c-2.094,2.965-6.2,15.567-3.785,17.227,2.721,1.87,12.328.407,12.328.407a3.9,3.9,0,0,0-.141-2.219c-.451-.72-7.694-1.838-8.031-2.17s4.129-6.541,4.121-7.543S-311.99,475.854-311.99,475.854Z",
    transform: "translate(322.34 -463.448)",
    fill: "#899bfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M-300.952,499.806a6.284,6.284,0,0,0,.906.972.665.665,0,0,0,.366.075l-.462-.818Z",
    transform: "translate(317.509 -468.858)",
    fill: "#ffae73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M-301.163,498.646l1.976.942a.351.351,0,0,1-.325.128,4.676,4.676,0,0,1-.856-.229Z",
    transform: "translate(317.556 -468.596)",
    fill: "#ffae73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(12.228 21.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M-300.326,499.442l15.577-.11,4.6-11.685-15.553.11Z",
    transform: "translate(305.139 -487.646)",
    fill: "#1e3865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M-285.974,502.153l-20.57.145,0,.454,20.387-.144Z",
    transform: "translate(306.543 -490.923)",
    fill: "#1e3865"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M-285.778,495.036a.54.54,0,0,0-.534-.738,1.062,1.062,0,0,0-.949.748.54.54,0,0,0,.534.739A1.063,1.063,0,0,0-285.778,495.036Z",
    transform: "translate(302.195 -489.149)",
    fill: "#e8f2fa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySubmitted);
export default __webpack_public_path__ + "static/media/SurveySubmitted.e3801c070e0b0bfd4dea415363b20f5d.svg";
export { ForwardRef as ReactComponent };